import React from 'react';
import iconTemplate from './IconTemplate';

export default iconTemplate(
    <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M11.7063 2.08326C12.584 2.05356 13.4786 2.05356 14.3564 2.05356C16.3642 2.05356 18.4602 2.05356 20.2401 2.40907C21.2254 2.60587 21.9577 3.40727 22.1592 4.39163C22.4461 5.79274 22.4461 6.86743 22.4461 9.17434C22.4461 11.4813 22.4461 12.5559 22.1592 13.9571C21.9577 14.9414 21.2254 15.7428 20.2401 15.9396C18.7416 16.2389 17.0192 16.2862 15.314 16.2937"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.84934 10.2902C3.97129 10.2902 1.23915 12.3605 1.58279 15.218C1.60949 15.44 1.64136 15.6729 1.67838 15.9206C1.78855 16.6579 2.43145 17.1936 3.17689 17.1936H4.02901L4.65069 21.0532C4.82643 22.1443 5.76813 22.9464 6.87325 22.9464C7.97837 22.9464 8.92008 22.1443 9.09582 21.0532L10.4801 14.3827H12.4492C15.6629 14.3827 15.8879 10.2902 12.4492 10.2902H6.84934Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.81062 7.57805C8.35347 7.57805 9.22133 6.7102 9.22133 5.16734C9.22133 3.62448 8.35347 2.75662 6.81062 2.75662C5.26776 2.75662 4.3999 3.62448 4.3999 5.16734C4.3999 6.7102 5.26776 7.57805 6.81062 7.57805Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>,
) as React.FC;
